import {
  ContractDetailCustomFieldInterface,
  ContractDetailInterface
} from '../../../interfaces/dto/contract-detail/contract-detail-interface';

export class ContractDetailModel implements ContractDetailInterface {
  ciaId: number | undefined;
  clientAddress: string = '';
  clientAlias: string = '';
  clientBirthDate: string = '';
  clientEmail: string = '';
  clientLocation: string = '';
  clientMobile: string = '';
  clientName: string = '';
  clientNif: string = '';
  clientPhone: string = '';
  clientPostalCode: string = '';
  clientSecondPhone: string = '';
  collectionAgentId: string = '';
  collectionAgentName: string = '';
  identityCard: string = '';
  isInsurance: boolean = false;
  nameRamo: string = '';
  policyEffectDate: string = '';
  policyEmissionDate: string = '';
  policyExpirationDate: string = '';
  policyFormOfPayment: string = '';
  policyId: number | undefined;
  policyNumber: string = '';
  policyStartDate: string = '';
  policyState: string = '';
  productId: number | undefined;
  productName: string = '';
  customFields: ContractDetailCustomFieldInterface[] = [];

  constructor(init?: Partial<ContractDetailModel>) {
    Object.assign(this, init);
  }
}
